// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { vcBaseUrl } from '.'


type UpdateDeletionRequestResponse = SuccessResponse | FailedResponse

export class UpdateDeletionRequest extends Request {
    private constructor(userId: string, init?: RequestInit) { super(`${vcBaseUrl}/user/${userId}/deletion-request`, init) }

    static async init(userId: string, init?: RequestInit) {
        return new UpdateDeletionRequest(userId, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders('Clerk-Token', init?.headers)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<UpdateDeletionRequestResponse>(await response.json())
        console.info('Update Deletion Request Results:', data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
